import { PencilSquareIcon } from "@heroicons/react/24/solid";

import Button from "../../../app/universalComponents/Button";
import Modal from "../../../app/universalComponents/Modal";
import { useState } from "react";
import { deleteTicketType, toggleTicketTypeForceSoldOut, toggleTicketTypeHiding } from "../../create-edit/createEditApi";

const confirmations = {
    delete: {
        label: "Delete ticket batch",
        message: "This will delete this ticket batch forever.",
    },
    hide: {
        label: "Hide ticket batch",
        message: "This will hide this ticket batch from buyers. You can unhide it at any time.",
    },
    unhide: {
        label: "Unhide ticket batch",
        message: "This will make this ticket batch visible to buyers.",
    },
    endSales: {
        label: "Stop ticket batch",
        message: "This will stop sales for this ticket batch and mark it as sold out to buyers. You can reopen sales at any time."
    },
    restartSales: {
        label: "Restart ticket batch",
        message: "This ticket batch will be made available for purchase again."
    },
};

export default function TicketActions({ event, ticketType, onEdit }) {
    const [pendingAction, setPendingAction] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    function closeConfirmation() {
        if (isSubmitting) return;

        setPendingAction(null);
    }

    async function confirmAction() {
        if (!pendingAction || isSubmitting) return;

        setIsSubmitting(true);

        try {
            if (pendingAction === "delete") {
                await deleteTicketType(event.id, ticketType.id);
            }

            if (pendingAction === "hide" || pendingAction === "unhide") {
                await toggleTicketTypeHiding(event.id, ticketType.id);
            }

            if (pendingAction === "endSales" || pendingAction === "restartSales") {
                await toggleTicketTypeForceSoldOut(event.id, ticketType.id);
            }

            window.location.reload();
        } catch (error) {
            alert("Something went wrong. Try again later.");
            setIsSubmitting(false);
        }
    }

    function renderStatusButtons() {
        if (event.status === "draft") {
            return (
                <Button variant="secondary" tone="red" onClick={() => setPendingAction("delete")}>
                    Delete Batch
                </Button>
            );
        }

        if (ticketType.status === "hidden") {
            return (
                <Button onClick={() => setPendingAction("unhide")} variant="secondary">
                    Unhide
                </Button>
            );
        }

        if (ticketType.status === "active") {
            return (
                <>
                    {ticketType.can_hide &&
                        <Button onClick={() => setPendingAction("hide")} variant="secondary">
                            Hide
                        </Button>
                    }

                    <Button onClick={() => setPendingAction("endSales")} tone="red">
                        Stop Sales
                    </Button>
                </>
            );
        }

        if (ticketType.status === "forced_sold_out") {
            return (
                <>
                    {ticketType.can_hide &&
                        <Button onClick={() => setPendingAction("hide")} variant="secondary">
                            Hide
                        </Button>
                    }

                    <Button onClick={() => setPendingAction("restartSales")} tone="green">
                        Resume Sales
                    </Button>
                </>
            );
        }

        if (ticketType.can_hide && ["past", "upcoming", "sold_out"].includes(ticketType.status)) {
            return (
                <Button onClick={() => setPendingAction("hide")} variant="secondary">
                    Hide
                </Button>
            );
        }

        return null;
    }

    const confirmation = confirmations[pendingAction];

    return (
        <>
            <div className="flex gap-2 text-sm">
                {renderStatusButtons()}

                <button type="button" onClick={onEdit} className="text-2xl transition-transform duration-200 hover:scale-105">
                    <PencilSquareIcon className="size-8" aria-hidden="true" />
                </button>
            </div>

            <Modal isOpen={pendingAction !== null} onClose={closeConfirmation} label={confirmation?.label} className="w-full max-w-sm p-4">
                <p className="text-sm text-gray-600">
                    {confirmation?.message}
                </p>

                <div className="mt-4 flex gap-2 text-sm">
                    <Button onClick={closeConfirmation} variant="secondary" disabled={isSubmitting} className="flex-1">
                        Cancel
                    </Button>

                    <Button onClick={confirmAction} disabled={isSubmitting} className="flex-1">
                        Confirm
                    </Button>
                </div>
            </Modal>
        </>
    );
}